import i18n from '@/plugins/i18n';

const endpointGraphs = {
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('apm.endpoint-load'),
      header: {
        title: i18n.global.t('loadTitle'),
        titleIcon: '',
        content: [],
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
      },
      serviceName:
        'eyduYW1lJzprYWZrYV9jb2luc3VtZXIsJ3RlYW1JRCc6YzA0OWExMGYtZTE0Yi00ZjFhLWIwNGMtMTFmNDdhMzZiM2EwLCd0eXBlJzonQSd9.1',
      endpointName:
        'eyduYW1lJzprYWZrYV9jb2luc3VtZXIsJ3RlYW1JRCc6YzA0OWExMGYtZTE0Yi00ZjFhLWIwNGMtMTFmNDdhMzZiM2EwLCd0eXBlJzonQSd9.1_L3Byb2R1Y3Qve2lkfQ==',
      capability: 'APM',
      chartColor: ['#008FFB'],
      height: '12.5em',
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'endpoint_total_call',
      queryMetricType: 'readMetricsValues',
      childQueries: [
        {
          entityType: 'Endpoint',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'endpoint_cpm',
          queryMetricType: 'readMetricsTotalValue',
          name: 'total',
        },
        {
          entityType: 'Endpoint',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'endpoint_cpm',
          queryMetricType: 'readMetricsValue',
          name: 'pm',
        },
      ],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('cpmWithFullForm'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfCalls'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('error'),
      header: {
        title: i18n.global.t('error'),
        titleIcon: 'error',
        content: [],
        isError: true,
        displayCustomButton: true,
        customButtonProp: {
          title: i18n.global.t('apm.error-traces'),
          key: 'error',
        },
      },
      serviceName:
        'eyduYW1lJzprYWZrYV9jb2luc3VtZXIsJ3RlYW1JRCc6YzA0OWExMGYtZTE0Yi00ZjFhLWIwNGMtMTFmNDdhMzZiM2EwLCd0eXBlJzonQSd9.1',
      endpointName:
        'eyduYW1lJzprYWZrYV9jb2luc3VtZXIsJ3RlYW1JRCc6YzA0OWExMGYtZTE0Yi00ZjFhLWIwNGMtMTFmNDdhMzZiM2EwLCd0eXBlJzonQSd9.1_L3Byb2R1Y3Qve2lkfQ==',
      capability: 'APM',
      chartColor: ['#FF8022'],
      height: '12.5em',
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'endpoint_error_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [
        {
          entityType: 'Endpoint',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'endpoint_error_percent',
          queryMetricType: 'readMetricsValue',
          name: 'percentage',
        },
        {
          entityType: 'Endpoint',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'endpoint_epm',
          queryMetricType: 'readMetricsTotalValue',
          name: 'total',
        },
        {
          entityType: 'Endpoint',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'endpoint_epm',
          queryMetricType: 'readMetricsValue',
          name: 'pm',
        },
      ],
      chartType: 'ApexChartLine',
      unit: 'No',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfErrors'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('apm.endpoint-successful-rate'),
      header: {
        title: i18n.global.t('responseTimeWithoutUnit'),
        titleIcon: 'responseTime',
        content: [],
        displayOnlyUnit: true,
        displayCustomButton: true,
        customButtonProp: {
          title: i18n.global.t('apm.slow-traces'),
          key: 'slow',
        },
      },
      serviceName:
        'eyduYW1lJzprYWZrYV9jb2luc3VtZXIsJ3RlYW1JRCc6YzA0OWExMGYtZTE0Yi00ZjFhLWIwNGMtMTFmNDdhMzZiM2EwLCd0eXBlJzonQSd9.1',
      endpointName:
        'eyduYW1lJzprYWZrYV9jb2luc3VtZXIsJ3RlYW1JRCc6YzA0OWExMGYtZTE0Yi00ZjFhLWIwNGMtMTFmNDdhMzZiM2EwLCd0eXBlJzonQSd9.1_L3Byb2R1Y3Qve2lkfQ==',
      capability: 'APM',
      chartColor: ['#98ED78'],
      height: '12.5em',
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'endpoint_avg',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      unit: i18n.global.t('ms-average'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('responseTimeWithUnit'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
      compareTrend: true,
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('apm.endpoint-percentile-response-time'),
      height: '12.5em',
      header: {
        title: i18n.global.t('percentileResponseTimeTitle'),
        titleIcon: '',
        content: [],
        toolbar: true,
        HideCenterMiscContent: true,
      },
      serviceName:
        'eyduYW1lJzprYWZrYV9jb2luc3VtZXIsJ3RlYW1JRCc6YzA0OWExMGYtZTE0Yi00ZjFhLWIwNGMtMTFmNDdhMzZiM2EwLCd0eXBlJzonQSd9.1',
      endpointName:
        'eyduYW1lJzprYWZrYV9jb2luc3VtZXIsJ3RlYW1JRCc6YzA0OWExMGYtZTE0Yi00ZjFhLWIwNGMtMTFmNDdhMzZiM2EwLCd0eXBlJzonQSd9.1_L3Byb2R1Y3Qve2lkfQ==',
      chartColor: ['#5CA8FF', '#0DCEBF', '#FFCC55', '#A0A7E6', '#EA7699'],
      capability: 'APM',
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'endpoint_percentile',
      queryMetricType: 'readLabeledMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'ms',
      metricLabels: 'P50, P75, P90, P95, P99',
      labelsIndex: '0, 1, 2, 3, 4',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentileUnit'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
  ],
};

export default endpointGraphs;
